import type { ComponentProps, ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type StatusSectionProps = ComponentProps<"section"> & {
  title: string
  aside?: string
  children?: ReactNode
}

// Shared section wrapper for the three "list" blocks on the page
// (Services, Providers, Recent incidents). Pulling this out lets
// the section bodies stay presentational while the heading + label
// + spacing rules live in one place. Visually a Card without the
// `ui-card` chrome -- the page ends up too dense if every section
// is a fully-bordered card.
function StatusSection(props: Readonly<StatusSectionProps>) {
  const { title, aside, className, children, ...sectionProps } = props
  return (
    <section
      className={cn("flex flex-col gap-3", className)}
      aria-label={title}
      {...sectionProps}
    >
      <header className="flex items-baseline gap-3">
        <h2 className="m-0 text-base font-semibold tracking-tight">{title}</h2>
        {aside && <p className="m-0 text-xs text-muted-foreground">{aside}</p>}
      </header>
      {children}
    </section>
  )
}

export default StatusSection
